export default "__VITE_ASSET__D9Bz4ywa__"